export function formatImpersonatedActor(userName, { impersonated, impersonatedByName, showAdmin } = {}) {
  if (!userName || !impersonated) return userName || ""
  if (showAdmin && impersonatedByName) {
    return `${userName} (impersonated by ${impersonatedByName})`
  }
  return `${userName} (impersonated)`
}
